import React from 'react';
import { updateAdminEmail, updateAdminPassword } from '../../api/adminApi';
import AccountSettings from '../../components/settings/AccountSettings';

const AdminAccountSettings = ({ user, onUserUpdated }) => {
  return (
    <AccountSettings
      initialEmail={user?.email || ''}
      onSaveEmail={updateAdminEmail}
      onSavePassword={updateAdminPassword}
      onUserUpdated={onUserUpdated}
      currentUser={user}
    />
  );
};

export default AdminAccountSettings;
